export default {
  link: '/collections/anatoliy-tarasov-dlya-razvitiya-sovetskogo-hokkeya',
  previewSrc: 'tarasov.png',
  title: 'Роль Анатолия Тарасова в развитии Советского хоккея',
  announce:
    'Клуб «Золотая шайба» и портал ИСТОРИЯ.РФ публикуют воспоминания Владимира Акопяна',
  model_type: 'specialprojectsection',
  type: 'second',
  gallery: [
    {
      static: 'hockey',
      previewSrc: 'hockey-1.png',
      title: 'История хоккея России',
    },
    {
      static: 'hockey',
      previewSrc: 'hockey-2.jpeg',
      title: 'История хоккея России',
    },
    {
      static: 'hockey',
      previewSrc: 'hockey-3.jpeg',
      title: 'Россия – Канада (1954-1972 гг.)',
    },
    {
      static: 'hockey',
      previewSrc: 'hockey-4.jpeg',
      title: 'История хоккея России',
    },
    {
      static: 'hockey',
      previewSrc: 'hockey-5.jpeg',
      title: 'Чемпионат Мира 1955 г.',
    },
    {
      static: 'hockey',
      previewSrc: 'hockey-6.jpeg',
      title: 'История хоккея России',
    },
    {
      static: 'hockey',
      previewSrc: 'hockey-7.jpeg',
      title: 'История хоккея России',
    },
  ],
};
